import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { randomId } from 'server/shared/helpers/random';
import { formatTimeNumber } from 'server/shared/helpers/time';
import { Shift } from 'server/shared/models/shift';
import { TimeErrorStateMatcher } from '../../job-edit.component';

@Component({
  selector: 'edit-time-dialog',
  templateUrl: 'edit-time-dialog.html',
})
export class EditTimeDialog {
  id = randomId().slice(0, 3);

  timeMatcher = new TimeErrorStateMatcher();
  from: string;
  to: string;

  constructor(
    public dialogRef: MatDialogRef<EditTimeDialog>,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: Shift,
  ) {
    this.from = formatTimeNumber(data.from);
    this.to = formatTimeNumber(data.to);
  }

  close(): void {
    let from = Number.parseInt(this.from.replace(':', ''), 10);
    let to = Number.parseInt(this.to.replace(':', ''), 10);

    let fromInvalid = formatTimeNumber(from) == 'Invalid';
    let toInvalid = formatTimeNumber(to) == 'Invalid';
    if (!fromInvalid && !toInvalid) {
      this.dialogRef.close({ from, to });
    }
  }
}
